var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"px-3 pt-3 pb-12",attrs:{"tile":true}},[_c('v-responsive',{staticClass:"mx-auto"},[_c('v-skeleton-loader',{ref:"skeleton",staticClass:"mx-auto",attrs:{"boilerplate":false,"type":"paragraph@4","tile":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }